import { useState, useCallback } from 'react';
import { createPortal } from 'react-dom';
import { FiHelpCircle } from 'react-icons/fi';

/**
 * 通用信息 Tooltip 组件
 * hover 显示自定义提示内容
 */
export function InfoTooltip({ 
  content, 
  title,
  iconClassName = 'text-slate-500 text-xs' 
}) {
  const [showTooltip, setShowTooltip] = useState(false);
  const [tooltipPosition, setTooltipPosition] = useState({ x: 0, y: 0 });

  const handleMouseEnter = useCallback((event) => {
    const rect = event.currentTarget.getBoundingClientRect();
    setTooltipPosition({
      x: rect.left + rect.width / 2,
      y: rect.top - 8
    });
    setShowTooltip(true);
  }, []);

  const handleMouseLeave = useCallback(() => {
    setShowTooltip(false);
  }, []);

  return (
    <>
      <span
        onMouseEnter={handleMouseEnter}
        onMouseLeave={handleMouseLeave}
        className="inline-flex items-center"
      >
        <FiHelpCircle className={`cursor-help hover:text-slate-300 transition-colors ${iconClassName}`} />
      </span>

      {showTooltip && typeof document !== 'undefined' && createPortal(
        (
          <div
            className="fixed rounded-xl bg-slate-900 border border-slate-700 shadow-xl backdrop-blur-xl px-3 py-2 text-xs text-slate-200"
            style={{
              left: `${tooltipPosition.x}px`,
              top: `${tooltipPosition.y}px`,
              transform: 'translate(-50%, -100%)',
              zIndex: 9999
            }}
          >
            {title && (
              <div className="whitespace-nowrap">
                <span className="text-sky-400 font-medium">{title}</span>
              </div>
            )}
            <div className={`text-slate-400 ${title ? 'mt-1' : ''}`}>{content}</div>
          </div>
        ),
        document.body
      )}
    </>
  );
}
